<template>
    <div>
        <rq-banner
            variant="error"
            :message="dataPumpOutOfSyncMsg"
            icon="fas fa-exclamation-triangle"
            :visible="isDataPumpOutOfSync"
        />
        <rq-banner
            variant="error"
            :message="titleCompanyNotConfiguredMsg"
            icon="fas fa-exclamation-triangle"
            :visible="isTitleCompanyNotConfigured"
        />
        <div class="breadcrumb-container">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"
                    v-for="(item, index) in list"
                    :key="index">
                    {{displayValue(item)}}
                </li>
            </ol>
            <div class="breadcrumb-cust-info">
                <span v-if="showFileNumber" class="breadcrumb-file-no">
                    File No: <span automation_id="spn_fileNumber">{{fileNumber}}</span>
                </span>
                <!-- <span v-if="useOrderEntry && showFileNumber">
                    <b-btn :automation_id="elementName('btn_archive')"
                              :ref="elementName('btn_archive')"
                              variant="theme"
                              class="ms-3"
                              @click="onClickArchive"
                              v-rq-tooltip="{ title: `${isArchived ? 'Unarchive' : 'Archive'} File`, show: false, trigger: 'hover' }"
                              v-if="useOrderEntry && showFileNumber">
                        {{isArchived ? "Unarchive" : "Archive"}}
                    </b-btn>
                </span> -->
                <span v-if="showSaveInBreadcrumb">
                    <b-btn :automation_id="elementName('btn_save')"
                              :ref="elementName('btn_save')"
                              variant="theme"
                              class="ms-3"
                              @click="onClick"
                              v-rq-tooltip="{ title: `Save ${itemTypeName}`, show: false, trigger: 'hover' }"
                              v-if="showSaveInBreadcrumb"
                              v-focus>
                        Save
                    </b-btn>
                </span>
                <slot></slot>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapState, mapGetters } from "vuex";
    import { ORDER_MUTATIONS } from '@/store/mutations';

    export default {
        name: "AppBreadcrumb",
        data() {
            return {
            };
        },
        props: {
            list: {
                type: Array,
                required: true,
                default: () => []
            }
        },
        computed: {
            ...mapGetters([
                "fileOrder"
            ]),
            itemTypeName() { return _.get(this.$route.meta, "itemTypeName") || ""; },
            showFileNumber () {
                return _.get(this, "list[0].meta.label", "") === "File";
            },
            showSaveInBreadcrumb() {
                 return _.get(this.$route.meta, "showSaveInBreadcrumb") || false;
            },
            fileNumber() {
                return _.get(this, "fileOrder.fileNum", "");
            },
            orderUniqueId() {
                return _.get(this, "fileOrder.uniqueId", "");
            },
            // isArchived() {
            //     return _.get(this, "fileOrder.isArchivedOrder", "");
            // },
            dataPumpOutOfSyncMsg() {
                return `The Datapump is out of date.  Using Version: ${this.$store.getters.site.dataPumpVersion}, Expecting Version: ${this.$store.getters.site.expectedDataPumpVersion}`;
            },
            isDataPumpOutOfSync() {
                if(this.useOrderEntry || this.hasHorizonTenant) return false;
                return !_.isEqual(this.$store.getters.site.dataPumpVersion, this.$store.getters.site.expectedDataPumpVersion);
            },
            titleCompanyNotConfiguredMsg() {
                return "Your Title Company is not configured, please contact your administrator.";
            },
            isTitleCompanyNotConfigured() {
                return _.isEqual(this.$store.getters.site.titleCompanyName, "Unknown");
            },
            useOrderEntry() {
                return _.parseBool(this.$store.getters.site.useOrderEntry, false);
            },
            hasHorizonTenant() {
                return !_.isNullOrEmpty(this.$store.getters.site.otherTenantName);
            },
        },
        methods: {
            displayValue (item) {
                let itemName = item.name || item;
                let labelName = _.get(item, "meta.label", itemName);
                return labelName;
            },
            getParentNav(item) {
                if(this.list && this.list.length > 0) {
                    return this.list[0];
                }
            },
            elementName(prefix="", suffix="") { return _.snakeCase(`${prefix} ${this.itemTypeName} ${suffix}`); },
            onClick(e) {
                this.$events.$emit(`save:${this.elementName()}`);
            },
            // onClickAdd(e) {
            //     const self = this;
            //     self.$router.push({ name: "titlecompany:fmaddfile"});
            // },
            // onClickArchive(e) {
            //     const self = this;
            //     let apiromise = self.$api.OrderApi.archiveFile(self.orderUniqueId, !self.isArchived);

            //     self.$rqBusy.wait(apiromise, { topLevel: true })
            //         .then((result) => {
            //             if (result) {
            //                 let fileOrder = _.clone(self.fileOrder);
            //                 fileOrder.isArchivedOrder = !self.isArchived;
            //                 self.$store.commit(ORDER_MUTATIONS.SET_FILE_ORDER, fileOrder);
            //                 self.$toast.success({ message: `Your file has been ${self.isArchived ? '' : 'un'}archived.` });
            //             } else {
            //                 self.$toast.error({ message: `There was a problem ${self.isArchived ? 'un' : ''}archiving your file.` });
            //             }
            //         })
            //         .finally(() => {
            //             self.refresh();
            //         });
            // }
        }
    };
</script>
